import clsx from 'clsx'

interface Props {
  isUsingDimensionList: boolean
  onIsUsingDimensionListChange: (isUsingDimensionList: boolean) => void
}

const DimensionListOrCustomToggle = ({
  isUsingDimensionList,
  onIsUsingDimensionListChange,
}: Props) => (
  <div className='inline-flex shrink-0 rounded-md border border-gray-200 bg-gray-100 p-0.5 shadow-sm'>
    <button
      type='button'
      className={clsx(
        'rounded px-2.5 py-1 text-xs font-medium transition-colors',
        isUsingDimensionList
          ? 'bg-white text-gray-900 shadow-sm'
          : 'text-gray-600 hover:text-gray-900',
      )}
      onClick={() => onIsUsingDimensionListChange(true)}
    >
      From list
    </button>
    <button
      type='button'
      className={clsx(
        'rounded px-2.5 py-1 text-xs font-medium transition-colors',
        !isUsingDimensionList
          ? 'bg-white text-gray-900 shadow-sm'
          : 'text-gray-600 hover:text-gray-900',
      )}
      onClick={() => onIsUsingDimensionListChange(false)}
    >
      Custom value
    </button>
  </div>
)

export default DimensionListOrCustomToggle

